var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('treeselect',{attrs:{"options":_vm.options,"isStatic":true},on:{"input":_vm.handleInput},model:{value:(_vm.$i18n.locale),callback:function ($$v) {_vm.$set(_vm.$i18n, "locale", $$v)},expression:"$i18n.locale"}})
}
var staticRenderFns = []

export { render, staticRenderFns }